import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetonavimumbaiinnovacrysta() {



  const cardData = {


  keyword: "Pune to Navi Mumbai Innova Crysta",

  headingDescription: "Trustline Cab provides premium Pune to Navi Mumbai Innova Crysta cab services with spacious, comfortable, and chauffeur-driven vehicles for corporate travel, airport transfers, family vacations, business meetings, and outstation journeys. The Toyota Innova Crysta offers exceptional comfort, ample luggage space, and a smooth ride, making it an ideal choice for long-distance travel. Our professional drivers ensure safe, punctual, and hassle-free transportation with transparent pricing and no hidden charges. With doorstep pickup, easy online booking, flexible travel schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Pune to Navi Mumbai Innova Crysta taxi services.",

  topPlaces: [
    {
      title: "Kopar Khairane",
      description: "Kopar Khairane is a well-developed commercial and residential locality known for business establishments, corporate offices, educational institutions, and excellent connectivity."
    },
    {
      title: "Mahape",
      description: "Mahape is a leading IT and industrial hub in Navi Mumbai, home to software companies, technology parks, and multinational organizations."
    },
    {
      title: "Turbhe",
      description: "Turbhe is an important commercial and logistics center featuring wholesale markets, industrial units, warehouses, and transport facilities."
    },
    {
      title: "Nerul",
      description: "Nerul is a modern business and residential destination with corporate offices, premium hotels, healthcare facilities, and excellent infrastructure."
    },
    {
      title: "Millennium Business Park",
      description: "Millennium Business Park is one of Navi Mumbai's premier technology parks, housing IT companies, startups, and multinational corporations."
    },
    {
      title: "Mindspace Airoli",
      description: "Mindspace Airoli is a world-class business campus accommodating global technology companies, financial institutions, and corporate headquarters."
    },
    {
      title: "DY Patil Stadium",
      description: "DY Patil Stadium is a renowned venue for international cricket matches, sporting events, concerts, and entertainment programs."
    },
    {
      title: "Pandavkada Falls",
      description: "Pandavkada Falls is a scenic waterfall near Kharghar, attracting nature lovers with its lush greenery and beautiful monsoon landscapes."
    },
    {
      title: "Karnala Bird Sanctuary",
      description: "Karnala Bird Sanctuary is a popular eco-tourism destination known for birdwatching, trekking trails, rich biodiversity, and the historic Karnala Fort."
    },
    {
      title: "Utsav Chowk",
      description: "Utsav Chowk is a lively landmark in Kharghar surrounded by shopping centers, restaurants, cafés, and recreational attractions."
    }
  ],






"services": [
  {
    "name": "Innova Crysta Pune to Navi Mumbai",
    "description": "Book Innova Crysta Pune to Navi Mumbai for premium family travel, airport transfers, corporate trips, and comfortable outstation journeys with experienced chauffeurs."
  },
  {
    "name": "Ertiga Pune to Navi Mumbai",
    "description": "Hire Ertiga Pune to Navi Mumbai for affordable 6 to 7 seater travel with spacious seating, AC comfort, and professional drivers."
  },
  {
    "name": "Sedan Pune to Navi Mumbai",
    "description": "Choose Sedan Pune to Navi Mumbai for budget-friendly business travel, airport transfers, and one-way or round-trip journeys."
  },
  {
    "name": "Kia Carens Pune to Navi Mumbai",
    "description": "Book Kia Carens Pune to Navi Mumbai for comfortable family trips, airport travel, and outstation rides with ample luggage space."
  },
  {
    "name": "Swift Dzire Pune to Navi Mumbai",
    "description": "Hire Swift Dzire Pune to Navi Mumbai for economical intercity travel with clean AC vehicles and reliable chauffeurs."
  },
  {
    "name": "Hyundai Aura Pune to Navi Mumbai",
    "description": "Travel with Hyundai Aura Pune to Navi Mumbai for affordable, safe, and comfortable outstation taxi service."
  },
  {
    "name": "SUV Cab Pune to Navi Mumbai",
    "description": "Book SUV Cab Pune to Navi Mumbai for group travel, extra luggage, airport transfers, and long-distance comfort."
  },
  {
    "name": "Premium Cab Pune to Navi Mumbai",
    "description": "Choose Premium Cab Pune to Navi Mumbai for executive travel, luxury comfort, and professional chauffeur service."
  },
  {
    "name": "Luxury Cab Pune to Navi Mumbai",
    "description": "Hire Luxury Cab Pune to Navi Mumbai with premium vehicles for VIP travel, business meetings, and airport transfers."
  },
  {
    "name": "Family Cab Pune to Navi Mumbai",
    "description": "Book Family Cab Pune to Navi Mumbai with spacious vehicles, comfortable seating, and experienced drivers."
  },
  {
    "name": "Corporate Cab Pune to Navi Mumbai",
    "description": "Corporate Cab Pune to Navi Mumbai for executive travel, employee transportation, airport transfers, and business meetings."
  },
  {
    "name": "Executive Cab Pune to Navi Mumbai",
    "description": "Hire Executive Cab Pune to Navi Mumbai with premium AC vehicles and professional chauffeurs for business travel."
  },
  {
    "name": "Business Travel Pune to Navi Mumbai",
    "description": "Reliable Business Travel Pune to Navi Mumbai with punctual pickups, comfortable vehicles, and flexible travel schedules."
  },
  {
    "name": "Employee Transport Pune to Navi Mumbai",
    "description": "Employee Transport Pune to Navi Mumbai with dependable chauffeur-driven cabs for corporate organizations and business travel."
  },
  {
    "name": "Corporate Taxi Pune to Navi Mumbai",
    "description": "Book Corporate Taxi Pune to Navi Mumbai with affordable corporate packages and premium chauffeur-driven vehicles."
  },
  {
    "name": "Hinjewadi to Navi Mumbai Cab",
    "description": "Book Hinjewadi to Navi Mumbai cab with reliable drivers, AC vehicles, and affordable one-way or round-trip taxi service."
  },
  {
    "name": "Wakad to Navi Mumbai Cab",
    "description": "Hire Wakad to Navi Mumbai cab for business travel, airport transfers, and family trips with professional chauffeurs."
  },
  {
    "name": "Baner to Navi Mumbai Cab",
    "description": "Choose Baner to Navi Mumbai cab with fixed fares, clean vehicles, and reliable intercity taxi service."
  },
  {
    "name": "Kharadi to Navi Mumbai Cab",
    "description": "Book Kharadi to Navi Mumbai cab with doorstep pickup, transparent pricing, and experienced drivers."
  },
  {
    "name": "Hadapsar to Navi Mumbai Cab",
    "description": "Hire Hadapsar to Navi Mumbai cab for comfortable outstation travel and airport connectivity."
  },
  {
    "name": "Pimpri Chinchwad to Navi Mumbai Cab",
    "description": "Book Pimpri Chinchwad to Navi Mumbai cab for affordable intercity travel with clean AC vehicles."
  },
  {
    "name": "Viman Nagar to Navi Mumbai Cab",
    "description": "Choose Viman Nagar to Navi Mumbai cab with convenient airport access, reliable drivers, and fixed pricing."
  },
  {
    "name": "Kothrud to Navi Mumbai Cab",
    "description": "Book Kothrud to Navi Mumbai cab with Sedan, Ertiga, Innova Crysta, SUV, and premium vehicle options."
  },
  {
    "name": "Aundh to Navi Mumbai Cab",
    "description": "Hire Aundh to Navi Mumbai cab with professional chauffeurs, comfortable vehicles, and affordable fares."
  },
  {
    "name": "Shivajinagar to Navi Mumbai Cab",
    "description": "Book Shivajinagar to Navi Mumbai cab for safe, comfortable, and reliable intercity travel."
  },
  {
    "name": "Pune to Vashi Cab",
    "description": "Book Pune to Vashi cab with one-way, round-trip, and airport transfer options at transparent pricing."
  },
  {
    "name": "Pune to Belapur Cab",
    "description": "Hire Pune to Belapur cab with comfortable AC vehicles and experienced drivers for hassle-free travel."
  },
  {
    "name": "Pune to Nerul Cab",
    "description": "Choose Pune to Nerul cab for business trips, airport transfers, and family travel with reliable service."
  },
  {
    "name": "Pune to Kharghar Cab",
    "description": "Book Pune to Kharghar cab with fixed fares, instant booking, and professional chauffeur service."
  },
  {
    "name": "Pune to Airoli Cab",
    "description": "Hire Pune to Airoli cab for comfortable outstation travel with Sedan, Ertiga, Innova Crysta, and SUV vehicles."
  },
  {
    "name": "Pune to Ghansoli Cab",
    "description": "Book Pune to Ghansoli cab for affordable intercity travel with clean vehicles and experienced drivers."
  },
  {
    "name": "Pune to Kopar Khairane Cab",
    "description": "Choose Pune to Kopar Khairane cab with reliable service, transparent pricing, and comfortable AC cars."
  },
  {
    "name": "Pune to CBD Belapur Cab",
    "description": "Book Pune to CBD Belapur cab for business travel, airport transfers, and family journeys."
  },
  {
    "name": "Pune to Panvel Cab",
    "description": "Hire Pune to Panvel cab with professional chauffeurs and flexible one-way or round-trip travel options."
  },
  {
    "name": "Pune to Taloja Cab",
    "description": "Book Pune to Taloja cab with affordable fares, comfortable vehicles, and dependable chauffeur service."
  }
],

"tableData": [
  ["Innova Crysta Pune to Navi Mumbai", "Ertiga Pune to Navi Mumbai"],
  ["Sedan Pune to Navi Mumbai", "Kia Carens Pune to Navi Mumbai"],
  ["Swift Dzire Pune to Navi Mumbai", "Hyundai Aura Pune to Navi Mumbai"],
  ["SUV Cab Pune to Navi Mumbai", "Premium Cab Pune to Navi Mumbai"],
  ["Luxury Cab Pune to Navi Mumbai", "Family Cab Pune to Navi Mumbai"],
  ["Corporate Cab Pune to Navi Mumbai", "Executive Cab Pune to Navi Mumbai"],
  ["Business Travel Pune to Navi Mumbai", "Employee Transport Pune to Navi Mumbai"],
  ["Corporate Taxi Pune to Navi Mumbai", "Hinjewadi to Navi Mumbai Cab"],
  ["Wakad to Navi Mumbai Cab", "Baner to Navi Mumbai Cab"],
  ["Kharadi to Navi Mumbai Cab", "Hadapsar to Navi Mumbai Cab"],
  ["Pimpri Chinchwad to Navi Mumbai Cab", "Viman Nagar to Navi Mumbai Cab"],
  ["Kothrud to Navi Mumbai Cab", "Aundh to Navi Mumbai Cab"],
  ["Shivajinagar to Navi Mumbai Cab", "Pune to Vashi Cab"],
  ["Pune to Belapur Cab", "Pune to Nerul Cab"],
  ["Pune to Kharghar Cab", "Pune to Airoli Cab"],
  ["Pune to Ghansoli Cab", "Pune to Kopar Khairane Cab"],
  ["Pune to CBD Belapur Cab", "Pune to Panvel Cab"],
  ["Pune to Taloja Cab", ""]
],





whychoose: [
  {
    WhyChooseheading: "Premium Pune to Navi Mumbai Innova Crysta Service",
    WhyChoosedescription: "Trustline Travels offers premium Innova Crysta cab service from Pune to Navi Mumbai for comfortable, spacious, and hassle-free travel."
  },
  {
    WhyChooseheading: "Luxury Travel with Spacious Seating",
    WhyChoosedescription: "The Innova Crysta provides ample legroom, comfortable seating, and generous luggage space, making every journey enjoyable."
  },
  {
    WhyChooseheading: "Professional Chauffeurs",
    WhyChoosedescription: "Our experienced drivers ensure a safe, smooth, and punctual journey from Pune to Navi Mumbai through the expressway."
  },
  {
    WhyChooseheading: "Transparent Fare & Competitive Pricing",
    WhyChoosedescription: "Book your Innova Crysta with upfront pricing, detailed quotations, and no hidden charges."
  },
  {
    WhyChooseheading: "Ideal for Families & Corporate Groups",
    WhyChoosedescription: "The Innova Crysta is a perfect choice for family vacations, business meetings, airport transfers, and group travel."
  },
  {
    WhyChooseheading: "One Way & Round Trip Availability",
    WhyChoosedescription: "Choose between one-way travel, round trips, or customized itineraries based on your schedule."
  },
  {
    WhyChooseheading: "Pickup from Anywhere in Pune",
    WhyChoosedescription: "We provide doorstep pickup from homes, hotels, offices, Pune Airport, Pune Railway Station, and all major areas of Pune."
  },
  {
    WhyChooseheading: "Easy Booking with 24/7 Support",
    WhyChoosedescription: "Get instant fare quotations, quick booking confirmation, and dedicated customer assistance anytime."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Pune to Navi Mumbai Innova Crysta service?",
    answer: "Yes, Trustline Travels offers premium Innova Crysta cab services from Pune to Navi Mumbai for one-way, round-trip, airport, and corporate travel."
  },
  {
    question: "Can I book an Innova Crysta for one-way travel?",
    answer: "Yes, affordable one-way Innova Crysta bookings are available from Pune to Navi Mumbai."
  },
  {
    question: "How many passengers can travel in an Innova Crysta?",
    answer: "The Innova Crysta comfortably accommodates up to 6–7 passengers along with sufficient luggage space."
  },
  {
    question: "Do you provide pickup from Pune Airport and Railway Station?",
    answer: "Yes, we offer pickup from Pune Airport, Pune Railway Station, hotels, offices, and residential areas across Pune."
  },
  {
    question: "Can I book an Innova Crysta for a round trip?",
    answer: "Yes, we provide flexible round-trip packages for business travel, family tours, and personal visits."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable state taxes are generally charged separately unless specifically mentioned in your booking quotation."
  },
  {
    question: "Is Innova Crysta service available 24/7?",
    answer: "Yes, Trustline Cab provides Innova Crysta cab services round the clock for your convenience."
  },
  {
    question: "Is the Innova Crysta suitable for airport transfers?",
    answer: "Yes, the Innova Crysta is an excellent choice for airport transfers due to its spacious seating and large luggage capacity."
  },
  {
    question: "Can I reserve the Innova Crysta in advance?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability on your preferred travel date."
  },
  {
    question: "How can I book a Pune to Navi Mumbai Innova Crysta with Trustline Travels?",
    answer: "Simply share your pickup location, travel date, passenger count, and destination to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep More",
    feedback: "We booked an Innova Crysta from Pune to Navi Mumbai with Trustline Travels for a family trip. The vehicle was spacious, clean, and extremely comfortable throughout the journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavya Joshi",
    feedback: "The Innova Crysta provided by Trustline Travels exceeded our expectations. The driver was professional, the ride was smooth, and the extra luggage space made our travel completely stress-free.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Navi Mumbai Innova Crysta Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/pune-to-navi-mumbai-innova-crysta.webp",
  "description": "Book Pune to Navi Mumbai Innova Crysta cab service with Trustline Travels for premium and comfortable intercity travel. Choose from Innova Crysta, Ertiga, Sedan, Kia Carens, Swift Dzire, Hyundai Aura, SUV, and premium cab options for one-way, round-trip, and airport transfers available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8369"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹16/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/pune-to-navi-mumbai-innova-crysta"
  }
};



  return (
    <div>

<Helmet>
  <title>Pune to Navi Mumbai Innova Crysta | Premium Cab Service | +91 8087080034</title>

  <meta
    name="description"
    content="Book Pune to Navi Mumbai Innova Crysta cab with Trustline Travels for luxury and comfortable travel. Get premium Innova Crysta, Ertiga, Sedan, Kia Carens, Swift Dzire, SUV, and premium cab services for airport and outstation journeys."
  />

  <meta
    name="keywords"
    content="Innova Crysta Pune to Navi Mumbai, Ertiga Pune to Navi Mumbai, Sedan Pune to Navi Mumbai, Kia Carens Pune to Navi Mumbai, Swift Dzire Pune to Navi Mumbai, Hyundai Aura Pune to Navi Mumbai, SUV Cab Pune to Navi Mumbai, Premium Cab Pune to Navi Mumbai, Pune to Navi Mumbai Innova Crysta Cab, Pune Navi Mumbai luxury taxi, Pune to Navi Mumbai premium cab service, Pune to Navi Mumbai airport Innova cab, Pune to Navi Mumbai outstation taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/66.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetonavimumbaiinnovacrysta;